<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="critica-operadora-intermediaria"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>
      <p-floatlabel variant="on" class="mr-2">
        <p-select
          size="small"
          [options]="condicaoOptions"
          [(ngModel)]="selectedCondicao"
          dropdownIcon="pi pi-angle-down"
          (ngModelChange)="onFilterChange()"
          [style]="{ width: '240px' }"
          [filter]="true"
          optionLabel="label"
          optionValue="value"
          appendTo="body"
        ></p-select>
        <label>Condição</label>
      </p-floatlabel>
      <div class="flex align-items-center mr-2">
        <p-multiSelect
          display="chip"
          optionLabel="label"
          optionValue="value"
          [options]="dataRealizacaoOptions"
          [(ngModel)]="selectedDataRealizacao"
          dropdownIcon="pi pi-angle-down"
          placeholder="Data de realização"
          (ngModelChange)="onFilterChange()"
          styleClass="text-sm"
          [style]="{ width: '200px', height: '35.38px' }"
        >
          <ng-template let-option pTemplate="item">
            <div>
              <div>{{ option.label }}</div>
            </div>
          </ng-template>
        </p-multiSelect>
      </div>
      <bl-competencia
        class="mr-2"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <button
        data-smartpresentation="botao-pesquisar"
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="mr-4 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        [disabled]="!isDataRealizacaoFilled || !filterChanged"
        (click)="reloadData(true)"
      ></button>

      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
        (click)="abrirMenuExportacao($event, exportMenu)"
        pRipple
      >
        <i class="pi pi-file-export"></i>
      </button>
      <p-menu #exportMenu [popup]="true" [model]="exportMenuItems" styleClass="menu-exportacao"></p-menu>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-column flex-1 min-h-0">
    <div class="grid-wrapper">
      <ag-grid-angular
        #agGrid
        data-smartpresentation="ag-grid"
        class="ag-theme-balham w-full h-full"
        [style.height]="gridHeight$ | async"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
      >
      </ag-grid-angular>

      <div class="grid-footer">
        <small>Último processamento em: {{ dtUltimoProcessamento || '-' }}</small>
      </div>
    </div>

    <div class="pagination-container flex justify-content-center mt-3">
      <bl-pagination
        [data]="rowData"
        [total]="rowTotal"
        [(page)]="page"
        [(size)]="pageSize"
        [(reset)]="paginationReset"
        (onChange)="onPageChange($event)"
      >
      </bl-pagination>
    </div>
  </div>
</bl-page-card-container>

<p-dialog
  [(visible)]="detalheGuiaDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  header="Detalhes da guia/lançamento"
>
  <bl-detalhes-guia
    [operadora]="operadora"
    [cdGuiaMonitor]="detalheGuiaCodigo"
    (onChange)="showDetalheGuiaFor($event)"
  ></bl-detalhes-guia>
</p-dialog>
